import { render, staticRenderFns } from "./AskBuyAfterService.vue?vue&type=template&id=758a82a7&"
import script from "./AskBuyAfterService.vue?vue&type=script&lang=ts&"
export * from "./AskBuyAfterService.vue?vue&type=script&lang=ts&"
import style0 from "./AskBuyAfterService.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports